enum ActionType {
    setDicts = "SET_DICTS",
    setRequest = "SET_REQUEST",
    setWidgetSize = "SET_WIDGET_SIZE",
    setResult = "SET_RESULT",
    setRegionCode = "SET_REGION_CODE",
    setRegionDescription = "SET_REGION_DESCRIPTION",
    setSpecialisationCode = "SET_SPECIALISATION_CODE",
    setSpecialisationDescription = "SET_SPECIALISATION_DESCRIPTION",
    setSelectedDate = "SET_SELECTED_DATE",
    setPresentedDates = "SET_PRESENTED_DATES",
    setStartPresentedDateIndex = "SET_START_PRESENTED_DATE_INDEX",
    setStopPresentedDateIndex = "SET_STOP_PRESENTED_DATE_INDEX",
    setCurrentPresentedDateIndex = "SET_CURRENT_PRESENTED_DATE_INDEX",
    setServiceInOffice = "SET_SERVICE_IN_OFFICE",
    setBookVisit = "SET_BOOK_VISIT",
    setIsLoading = "SET_IS_LOADING",
    setSelectedTimeInterval = "SET_SELECTED_TIME_INTERVAL",
    setClinics = "SET_CLINICS",
    setClinicCode = "SET_CLINIC_CODE",
    setVendor = "SET_VENDOR",
    setDoctors = "SET_DOCTORS",
    setSpecialities = "SET_SPECIALITIES",
    setAggregatedData= "SET_AGGREGATED_DATA",
    setAggregatedDataToDisplay= "SET_AGGREGATED_DATA_TO_DISPLAY",
    setAvailableDays= "SET_AVAILABLE_DAYS",
    setClinicDescription = "SET_CLINIC_DESCRIPTION",
    setSlotsNotAvailable = "SET_SLOTS_NOT_AVAILABLE",
    setIsTelemedicineAvailable = "SET_IS_TELEMEDICINE_AVAILABLE",
    setIsOfficeAvailable = "SET_IS_OFFICE_AVAILABLE"
}

export default ActionType;